import "../../../../../css/AML/Spinner/Spinner.css";

function Spinner({ label = "Loading…" }) {
  return (
    <div role="status" aria-live="polite" className="spinner-wrap">
      <div className="spinner" />
      <div className="AML-Text-Body">{label}</div>
    </div>
  );
}

export { Spinner };